export const TimelineItems = [
    {
        position: 'Software Engineer',
        company: 'Amazon',
        time: 'April 2025 - Present (Full Time)',
        isExpanded: true,
        descriptionItems: [
            'Designed and deployed LLM-powered chatbot plugins hosted on AWS Lambda, enabling Amazon employees to query internal knowledge bases for compensation, performance, and talent management questions; scaled solution across multiple HR applications, supporting 50K+ monthly employee interactions.',
            'Built an AI-driven peer feedback summarization widget leveraging Claude 4 on AWS Bedrock, reducing time spent reviewing feedback by ~65% and improving manager decision-making efficiency.',
            'Developed a promotion writing assistant tool with a custom frontend widget that analyzes employee inputs and rewrites them in Amazon’s corporate language, helping employees produce higher-quality promotion documents 30% faster.',
            'Implemented THELMA (Task-Based Holistic Evaluation of LLM Applications) into production workflows using AWS Lambda orchestration; automated evaluation of precision, groundedness, and distinctness across all LLM calls, achieving a 90% model success rate.',
            'Integrated AWS X-Ray with ECS services and Bedrock for full observability of LLM workflows; created visual latency graphs and consolidated logging, reducing troubleshooting time by 40% and improving system reliability.',
            'Partnered with cross-functional teams (HR Tech, AI Research, and Platform Engineering) to deliver scalable LLM applications impacting 100K+ employees globally, while ensuring security, compliance, and cost optimization.',
        ],
        isNew: true,
    },
    {
        position: 'Software Engineer',
        company: 'AWS - Amazon',
        time: 'April 2024 - April 2025',
        isExpanded: true,
        descriptionItems: [
            'Delivered implementations to revamp Multi-factor Authentication for customer payment methods as part of an AWS wide campaign to improve customer security while verifying their payment method',
            'Crafted a plan to achieve 95% Pipelines CI/CD adherence, allowing for a 328% reduction of deployment time per week, the plan was executed by one engineer with just one sprint of effort.',
            'Drove the Backup Payment Method  project throughout all phases from design to implementation to rollout, accounting for the increase in collection rate of 1.2% by invoice and 0.9% by dollar amount, and increase in collected revenue of over $5MM/mo.',
            'Designed and implemented a backup payment instrument selection mechanism that was used for all payment use cases, and provides the flexibility for future extension for more complex payment instrument selection strategies.',
            'Collaborated with payments collections team for DynamoDB backfill and UX cases for a seamless customer experience.',
            'Feature launch announcement: https://tinyurl.com/AWS-BackupPaymentMethod',
        ],
        isNew: false,
    },
    {
        position: 'Software Engineer',
        company: 'Amazon Web Services (AWS)',
        time: 'May 2023 - August 2023 (Internship)',
        isExpanded: true,
        descriptionItems: [
            'Drove the AWS Payments WebOps revamp project throughout all phases from design to implementation to rollout taking ownership of the project from start to finish accounting for the increased productivity of thousands of customer service agents servicing over 200k customers requests per month.',
            'Collaborated with UX research, implementing heuristic practices for intuitive frontends, benefiting 100k  monthly users.',
            'Ensured secure service connectivity via end-to-end tests (Cypress) and unit tests (Jest, React Testing Library), integrated into automated CI/CD pipeline leading to 95% code coverage',
        ],
        isNew: false,
    },
    {
        position: 'Software Engineer',
        company: 'LABonWEB',
        time: 'Sept 2022 - March 2023 (Work Study)',
        isExpanded: false,
        descriptionItems: [
            'Designed browser-based interactive labs using high performance scientific computing, powered by the energy2D library, optimizing resource utilization.',
            'Enhanced visualization and analysis features within libraries, elevating simulation accuracy and student comprehension.',
            'Streamlined web app performance, resulting in rapid loading times for high fidelity lab simulations.',
            'Impacted thousands of students across 10 universities by delivering optimized and resource-efficient learning experiences.',

        ],
    },
    {
        position: 'Software Engineer',
        company: 'ModiFace - a L\'Oréal Company',
        time: 'May 2021 - April 2022 (Internship)',
        isExpanded: false,
        descriptionItems: [
            'Drove the virtual makeup integration video conferencing project from implementation to rollout accounting for a 20% increase in customer engagement while browsing cosmetic brand’s ecommerce sites allowing the customers to engage with beauty consultants over video conferencing in real time.',
            'Crafted a plan to achieve 40% improved efficiency in container load times for the end customers.',
            'Enhanced core augmented reality makeup SDK by introducing features and resolving critical bugs affecting over 700k customers from multiple cosmetic brands.',
        ],
    },
]
